<template lang="html">
  <v-dialog v-model="dialogBottommenu" max-width="720px" persistent max-height="700px" style="overflow-y: hidden; border-radius: 20px !important;">
    <v-card style="border-radius:20px;" class="Kanit">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text Kanit">
            <v-layout row wrap>
               <v-icon color="white">fas fa-border-all</v-icon>
              &nbsp;&nbsp;
              <p class="mb-0">เลือกเทมเพลต</p>
            </v-layout>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon flat @click="closeDialog">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text class="" style="height: 500px !important; overflow-x: hidden;">
        <v-icon>mdi-border-all</v-icon>

      <h3 style="padding-left:20px;">ใหญ่</h3>
      <v-layout row wrap  style="display: flex; padding-left:20px;">
        <v-radio-group v-model="templateSelected" v-for="item in item_picture_large" :key="item.id"  :mandatory="false" column style="margin-right: 20px;">
          <v-radio
            :value="item.id" style="display: none;">
          </v-radio>
          <v-img :src="'/static/templateBMsize/'+item.name" @click="templateSelected=item.id;" width="200px" height="100%" :contain="true" :class="(item.id == templateSelected)? 'selected':'nonselect'"></v-img>
      </v-radio-group>
    </v-layout>

    <h3 style="padding-left:20px;">เล็ก</h3>
    <v-layout row wrap justify-start style="display:flex; padding-left:20px;">
      <v-radio-group v-model="templateSelected" v-for="item in item_picture_small" :key="item.id" :mandatory="false"  column style="margin-right: 20px; display:flex; ">
        <v-radio
          :value="item.id" style="display: none;">
        </v-radio>
            <v-img :src="'/static/templateBMsize/'+item.name" @click="templateSelected=item.id;" width="200px" height="100%" :contain="true" :class="(item.id == templateSelected)? 'selected':'nonselect'" ></v-img>
        </v-radio-group>
      </v-layout>
      <div style="display: flex; justify-content: center;">
      <v-btn @click="closeDialog()" class="buttonCancel">ยกเลิก</v-btn>

      <v-btn @click="selectTemplate()" class="buttonSelect">เลือก</v-btn>
    </div>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogBottommenu: false,
    radioGroup: null
  },
  components: {},
  computed: {},
  data: () => ({
    item_picture_large: [
      { id: 1, name: 'BM1.png' },
      { id: 2, name: 'BM2.png' },
      { id: 3, name: 'BM3.png' },
      { id: 4, name: 'BM4.png' },
      { id: 5, name: 'BM5.png' },
      { id: 6, name: 'BM6.png' },
      { id: 7, name: 'BM7.png' }
    ],
    item_picture_small: [
      { id: 8, name: 'BM8.png' },
      { id: 9, name: 'BM9.png' },
      { id: 10, name: 'BM10.png' },
      { id: 11, name: 'BM11.png' },
      { id: 12, name: 'BM12.png' },
    ],
    templateSelected: 1
  }),
  created () {

  },
  methods: {
    closeDialog () {
      this.$emit('closeDialogSelectTemplate', false)
    },
    selectTemplate () {
      this.$emit('radio', this.templateSelected)
      this.closeDialog()
    }
  },
  watch: {
    dialogBottommenu () {
      this.templateSelected = this.radioGroup
    }
  }
}
</script>

<style lang="css" scoped>
.v-img{
  margin-right: 20px;
}
.selected {
  border: #0D47A1 3px solid;
  cursor: pointer;
  border-radius: 5px;
}
.nonselect {
  cursor: pointer;
}
.buttonCancel {
  border-radius: 25px;

}
.buttonSelect {
background: #19212c !important;
    color: white !important;
    border-radius: 25px !important;
}
>>>.v-input{
  flex: initial;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

</style>



// WEBPACK FOOTER //
// src/components/managebot/bottommenu/dialog/select_templateDialog.vue